/**
 * Returns the masked form of an email, a phone number, or a VIN.
 * @param value An email, phone number, or VIN to be masked
 */
export const maskValue = (value: string = ''): string => {
    value = value.trim();
    const isEmail = (/[^@]+@[^@.]+\.[^@]+/).test(value);
    const isPhone = (/^\+?1?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/).test(value);
    if (isEmail) {
        return value.replace(/^[^@]+/, (m) => m.replace(m.length > 4 ? /^(..)(.*)(..)$/ : /^(.)(.*?)(.?)$/, (_, a, b, c) => `${a}${'*'.repeat(b.length)}${c}`));
    }
    else if (isPhone) {
        return value.replace(/.*(\d{4})/, '(XXX) XXX-$1');
    }
    else {
        return value.replace(/.(?=.{6})/g, '*');
    }
};
